$(function () {
  $('.banner a.close').on('click', function (e) {
    e.preventDefault();
    var $banner = $(this).closest('div.banner');
    $banner.hide();

    var clearedCode = $banner.data('cookie-code');
    if (clearedCode !== null) {
      var options = $banner.data('cookie-options');
      $.cookie(clearedCode, true, options);
    }
  });
});
